import React from "react";
import { Drawer } from "antd";
import QuestionnaireBar from "../../../QuestionnaireBar";
import style from "./index.module.scss";
import { TopicsItem } from "../../../../../service";

interface AnswerCardDrawerProps {
    visible: boolean;
    onClose: () => void;
    checked: number;
    data: TopicsItem[];
    onChange: (val: number) => void;
}

export default function AnswerCardDrawer({
    visible,
    onClose,
    checked,
    data,
    onChange
}: AnswerCardDrawerProps) {
    function barChange(num: number) {
        onChange(num);
        onClose();
    }

    function close() {
        onClose();
    }

    return (
        <Drawer
            placement="right"
            closable={false}
            onClose={onClose}
            visible={visible}
            getContainer={false}
            maskClosable
            className={style.root}>
            {/*全部试题是否正确列表判断*/}
            <QuestionnaireBar
                checked={checked}
                data={data}
                onChange={barChange}
                onClose={close}
            />
        </Drawer>
    );
}
